import React from 'react';
import NeighborhoodPainPost from '../components/NeighborhoodPainPost';

const BlogPostArdenArcadePain = () => (
  <NeighborhoodPainPost
    data={{
      neighborhood: 'Arden-Arcade',
      slug: 'back-and-neck-pain-massage-arden-arcade',
      image:
        'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=1600&auto=format&fit=crop&q=80',
      driveMinutes: '15–20 minutes',
      driveNote:
        'the drive from Arden-Arcade to 2528 I Street via Business 80 or Arden Way is short and reliable',
      routes: [
        'From Arden Way / Arden Fair area: ~15 minutes via Business 80 south',
        'From near Watt Avenue: ~18–20 minutes via Business 80 or Fair Oaks Boulevard',
        'From Sierra Oaks: ~12–15 minutes via H Street',
      ],
      nearbyAreas: [
        'Arden-Arcade, Sacramento',
        'Sierra Oaks, Sacramento',
        'Carmichael',
        'Del Paso Manor, Sacramento',
        'Midtown Sacramento',
      ],
      pageTitle:
        'Back and Neck Pain Massage in Arden-Arcade | Ayumi Suzuki',
      hookLine:
        'Living in Arden-Arcade and looking for real relief from chronic back or neck pain?',
      dataTestId: 'arden-arcade-pain-blog-page',
    }}
  />
);

export default BlogPostArdenArcadePain;
